<ng-container *ngIf="product()?.id; else noProductId">
    <app-vendor-product-price-edit-widget [product]="product()" [dataTestid]="dataTestid()" />
</ng-container>
<ng-template #noProductId>
    <!-- <ngx-ui-loader #loader> </ngx-ui-loader> -->
    <div
        class="flex justify-center items-center choose-ngifloader-splitter"
        style="height: 100%; width: 100%; min-height: 400px"
    >
        <div
            class="shine"
            [attr.data-testid]="
                dataTestid() + '-formly-vendor-product-price-edit-widget-no-product-id'
            "
        >
            <h3
                [attr.data-testid]="
                    dataTestid() + '-formly-vendor-product-price-edit-widget-no-product-id-h3'
                "
            >
                {{ 'product.product-choose' | translate }}
            </h3>
        </div>
    </div>
</ng-template>
